import { render, staticRenderFns } from "./FaturasEad.vue?vue&type=template&id=a3b498dc&"
import script from "./FaturasEad.vue?vue&type=script&lang=js&"
export * from "./FaturasEad.vue?vue&type=script&lang=js&"
import style0 from "./FaturasEad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports